import {
  getChannelsApi,
  getTeamChannelMappingsApi,
  saveTeamChannelMappingApi,
  updateTeamChannelMappingApi,
  deleteTeamChannelMappingApi,
  getPluginFeaturesApi,
  updatePluginFeatureApi,
  getAuthDetailsApi,
  updateJiraAuthDetailsApi,
  getSlackAuthDetailsApi,
  getDarwinBoxAuthDetailsApi,
  updateDarwinBoxAuthDetailsApi,
  saveSlackApplauseMappingApi,
  getSlackApplauseDetailsApi,
  updateSlackApplauseChannelMappingApi,
  getLinkTokenApi,
  storePermanentAccountTokenApi,
  storePermanentAccountTokenFinchApi,
  deactivateMergeHRISApi,
  getMergeHRISAuthDetailsApi,
  getFinchHRISAuthDetailsApi,
  getCalendarAuthDetailsV2Api,
  getCalendarAuthURLsV2Api,
  getCalendarAuthCodeV2Api,
  deactivateCalendarPluginApiV2,
} from 'api/plugins';
import AuthorizationDetail from 'models/admin/authorizationDetail';
import Channel from 'models/admin/channel';
import DarwinBoxAuthorizationDetail from 'models/admin/darwinboxAuthorizationDetail';
import PluginFeature from 'models/admin/pluginFeature';
import TeamChannelMapping from 'models/admin/teamChannelMapping';

import { LOGIN_TYPES } from 'constants/ProjectConstants';

export const getChannels = ({ thirdPartyType }) =>
  getChannelsApi({
    thirdPartyType,
  }).then((res) =>
    res.entity.map((channelJSON) => {
      const channel = new Channel();
      channel.fromJSON(channelJSON);
      return channel;
    })
  );

export const getTeamChannelMappings = ({ thirdPartyType }) =>
  getTeamChannelMappingsApi({
    thirdPartyType,
  }).then((res) =>
    res.entity.map((mappingJSON) => {
      const mapping = new TeamChannelMapping();
      mapping.fromJSON(mappingJSON);
      return mapping;
    })
  );

export const saveTeamChannelMapping = ({ thirdPartyType, thirdPartyTeamId, thirdPartyTeamName, teamId }) => {
  const team = {
    uuid: teamId,
  };
  return saveTeamChannelMappingApi({
    thirdPartyType,
    thirdPartyTeamId,
    thirdPartyTeamName,
    team,
  }).then((res) => res);
};

export const saveSlackApplauseMapping = ({ thirdPartyType = 'slack', thirdPartyTeamId, thirdPartyTeamName }) =>
  saveSlackApplauseMappingApi({
    thirdPartyType,
    thirdPartyTeamId,
    thirdPartyTeamName,
  }).then((res) => res);

export const getSlackApplauseDetails = () => getSlackApplauseDetailsApi().then((res) => res.entity);

export const updateSlackApplauseChannelMapping = ({
  thirdPartyType = 'slack',
  thirdPartyTeamId,
  thirdPartyTeamName,
  mappingId,
}) =>
  updateSlackApplauseChannelMappingApi({
    thirdPartyType,
    thirdPartyTeamId,
    thirdPartyTeamName,
    mappingId,
  }).then((res) => res);

export const updateTeamChannelMapping = ({ thirdPartyType, id, thirdPartyTeamId, thirdPartyTeamName, teamId }) => {
  const team = {
    uuid: teamId,
  };
  return updateTeamChannelMappingApi({
    thirdPartyType,
    mappingId: id,
    thirdPartyTeamId,
    thirdPartyTeamName,
    team,
  }).then((res) => res);
};

export const deleteTeamChannelMapping = ({ thirdPartyType, mappingId }) =>
  deleteTeamChannelMappingApi({
    thirdPartyType,
    mappingId,
  }).then((res) => res);

export const getPluginFeatures = ({ thirdPartyType }) =>
  getPluginFeaturesApi({
    thirdPartyType,
  }).then((res) => {
    let features = res.entity;
    if (thirdPartyType === 'slack') {
      features = features?.filter((featureJSON) => featureJSON?.featureType === 'POST');
    }

    if (thirdPartyType === 'jira') {
      features = features?.filter(({ featureType }) => featureType !== 'JIRA_ISSUES');
    }

    return features?.map((featureJSON) => {
      const feature = new PluginFeature();
      feature.fromJSON(featureJSON);
      return feature;
    });
  });

export const updatePluginFeature = ({ thirdPartyType, id, featureType, enabled }) =>
  updatePluginFeatureApi({
    thirdPartyType,
    id,
    featureType,
    enabled,
  }).then((res) => res);

export const getAuthDetails = ({ thirdPartyType }) =>
  getAuthDetailsApi({
    thirdPartyType,
  }).then((res) => {
    if (res.entity) {
      const detail = new AuthorizationDetail();
      detail.fromJSON(res.entity);
      return detail;
    }
    return null;
  });

export const updateJiraAuthDetails = ({ displayName, workspaceUrl, loginType = LOGIN_TYPES.jira }) =>
  updateJiraAuthDetailsApi({
    displayName,
    workspaceUrl,
    loginType,
  }).then((res) => res);

export const getSlackAuthDetails = () => getSlackAuthDetailsApi().then((res) => res);

export const getDarwinboxAuthDetails = () =>
  getDarwinBoxAuthDetailsApi().then((res) => {
    if (res.entity) {
      const detail = new DarwinBoxAuthorizationDetail();
      detail.fromJSON(res.entity);
      return detail;
    }
    return null;
  });

export const updateDarwinBoxAuthDetails = ({ subdomain, apiKey, secretKey, uid, datasetKey }) =>
  updateDarwinBoxAuthDetailsApi({
    subdomain,
    apiKey,
    secretKey,
    uid,
    datasetKey,
  }).then((res) => res);

// HRIS plugin start
export const getLinkToken = (pluginType) => getLinkTokenApi(pluginType).then((res) => res.linkToken);

export const storePermanentAccountToken = ({ public_token }) =>
  storePermanentAccountTokenApi({ public_token }).then((res) => res);
export const storePermanentAccountTokenFinch = ({ public_token }) =>
  storePermanentAccountTokenFinchApi({ public_token }).then((res) => res);

export const deactivateMergeHRIS = () => deactivateMergeHRISApi().then((res) => res);

export const getMergeHRISAuthDetails = () => getMergeHRISAuthDetailsApi().then((res) => res);

export const getFinchHRISAuthDetails = () => getFinchHRISAuthDetailsApi().then((res) => res);

// HRIS plugin end

export const getCalendarAuthDetailsV2 = () => getCalendarAuthDetailsV2Api().then((res) => res.entity);

export const getCalendarAuthURLsV2 = ({ calendarType }) =>
  getCalendarAuthURLsV2Api({ calendarType }).then((res) => res.entity);

export const getCalendarAuthCodeV2 = ({ calendarType, code, error, error_description }) =>
  getCalendarAuthCodeV2Api({ calendarType, code, error, error_description }).then((res) => res.entity);

export const deactivateCalendarPluginV2 = () => deactivateCalendarPluginApiV2().then((res) => res.entity);
